/* Sinneszauber Merkliste
   Herz-Buttons [data-wish] auf Karten und Produktseiten, Z\u00e4hler [data-wish-count]
   im Header, Seitenleiste zum \u00d6ffnen \u00fcber [data-open-wish]. Speichert im Browser. */
(function () {
  const KEY = 'sz-wish';
  const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  let list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { list = []; }
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {} };
  const has = (h) => list.some((x) => x.h === h);
  const linkFor = (x) => (window.SZPreview ? '#p-' + x.h : x.url);

  function drawer() {
    let d = document.getElementById('WishDrawer');
    if (d) return d;
    d = document.createElement('div');
    d.className = 'drawer';
    d.id = 'WishDrawer';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML = `<div class="scrim" data-wish-close></div>
      <div class="sheet" role="dialog" aria-modal="true" aria-label="Merkliste">
        <div class="sheet-head"><h2>Merkliste</h2><button class="icon-btn" data-wish-close aria-label="Merkliste schlie\u00dfen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>
        <div class="sheet-body"></div>
      </div>`;
    document.body.appendChild(d);
    return d;
  }

  function render() {
    const n = list.length;
    document.querySelectorAll('[data-wish-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
    const d = document.getElementById('WishDrawer');
    if (!d) return;
    d.querySelector('.sheet-head h2').innerHTML = 'Merkliste' + (n ? ` <span class="mono muted">(${n})</span>` : '');
    d.querySelector('.sheet-body').innerHTML = n
      ? list.map((x) => `<div class="line">
          <a href="${esc(linkFor(x))}" data-wish-close>${x.image ? `<img src="${esc(x.image)}" alt="">` : ''}</a>
          <div><a class="t" href="${esc(linkFor(x))}" data-wish-close>${esc(x.title)}</a>
            ${x.price ? `<span class="v">ab ${fmt.format(Number(x.price))}</span>` : ''}
            <div><a class="btn ghost" style="padding:7px 14px;font-size:13px;margin-top:8px" href="${esc(linkFor(x))}" data-wish-close>Ansehen und Gr\u00f6\u00dfe w\u00e4hlen</a></div></div>
          <button type="button" class="remove" data-wish-remove="${esc(x.h)}">Entfernen</button>
        </div>`).join('')
      : `<div class="cart-empty"><p class="h" style="font-size:30px;font-style:italic">Noch nichts gemerkt.</p><p class="muted">Tipp auf das Herz bei einem Duft, um ihn hier zu sammeln und sp\u00e4ter zu vergleichen.</p></div>`;
  }

  function sync(scope) {
    (scope || document).querySelectorAll('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', has(b.dataset.wish)));
    render();
  }

  function open() { const d = drawer(); render(); d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); }
  function close() { const d = document.getElementById('WishDrawer'); if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); } }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      const h = b.dataset.wish;
      if (has(h)) list = list.filter((x) => x.h !== h);
      else list.unshift({ h, title: b.dataset.title, url: b.dataset.url, image: b.dataset.image, price: b.dataset.price });
      save();
      sync();
      b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
      return;
    }
    if (e.target.closest('[data-open-wish]')) { e.preventDefault(); open(); return; }
    const r = e.target.closest('[data-wish-remove]');
    if (r) { list = list.filter((x) => x.h !== r.dataset.wishRemove); save(); sync(); return; }
    if (e.target.closest('[data-wish-close]')) close();
  }, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  window.addEventListener('storage', (e) => { if (e.key === KEY) { try { list = JSON.parse(e.newValue || '[]'); } catch (_) {} sync(); } });

  window.SZWish = { sync, open };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync()); else sync();
})();
